<section class="contacts-panel">
  @if (!hasCompany()) {
    <!-- O CRUD e por id da empresa: sem ela salva, nao ha onde pendurar o contato. Explicar e
         melhor do que mostrar uma tabela vazia que recusa cadastro. -->
    <div class="contacts-panel__empty">
      <span>Salve a empresa para cadastrar os contatos dela.</span>
    </div>
  } @else {
    <header class="contacts-panel__header">
      <!-- Aviso do Relatorio de Risco no topo: empresa sem ninguem marcado tem o lote mensal
           nascendo vazio, e isso precisa aparecer AQUI, nao so na hora do envio. -->
      @if (notice(); as aviso) {
        <p
          class="contacts-panel__notice"
          [class.contacts-panel__notice--warn]="aviso.includes('Nenhum contato')">
          <i
            class="pi"
            [ngClass]="
              aviso.includes('Nenhum contato') ? 'pi-exclamation-triangle' : 'pi-envelope'
            "></i>
          <span>{{ aviso }}</span>
        </p>
      }

      @if (canCreate()) {
        <app-button
          [label]="'Adicionar contato'"
          [size]="'small'"
          [type]="'button'"
          [fitContent]="true"
          [disabled]="isSaving()"
          (sendButtonClick)="openNew()">
        </app-button>
      }
    </header>

    @if (isLoadingContacts()) {
      <div class="contacts-panel__loading">
        <app-cog-loading-spinner [size]="28"></app-cog-loading-spinner>
        <span>Carregando os contatos...</span>
      </div>
    } @else if (loadError()) {
      <p class="contacts-panel__error">
        <i class="pi pi-times-circle"></i>
        <span>{{ loadError() }}</span>
        <button type="button" class="contacts-panel__retry" (click)="load()">tentar de novo</button>
      </p>
    } @else if (!contacts().length) {
      <div class="contacts-panel__empty">
        <span>Esta empresa ainda não tem contatos cadastrados.</span>
        <span class="contacts-panel__empty-hint">
          Cadastre quem recebe o Relatório de Risco para o envio mensal já nascer com os
          destinatários certos.
        </span>
      </div>
    } @else {
      <table class="contacts-panel__table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>Área / cargo</th>
            <th>Tipos</th>
            <th>Observações</th>
            @if (hasRowActions()) {
              <th class="contacts-panel__actions-col"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (contact of contacts(); track contact.id) {
            <tr>
              <td>
                {{ contact.name }}
                <!-- Reservado (card 3472): só chega para quem tem COMPANYCONTACT_RESERVED. -->
                @if (contact.isReserved) {
                  <span
                    class="contacts-panel__chip contacts-panel__chip--reserved"
                    pTooltip="Só a Legatus vê este contato"
                    tooltipPosition="top">
                    <i class="pi pi-lock" aria-hidden="true"></i> Reservado
                  </span>
                }
                <!-- Representante legal (card 3643): assina os contratos de cliente. -->
                @if (contact.isLegalRepresentative) {
                  <span
                    class="contacts-panel__chip contacts-panel__chip--legal-rep"
                    pTooltip="Assina os contratos de cliente pela empresa"
                    tooltipPosition="top">
                    <i class="pi pi-file-edit" aria-hidden="true"></i> Representante legal
                  </span>
                }
              </td>
              <td class="contacts-panel__email">{{ contact.email }}</td>
              <td>{{ contact.phone || '—' }}</td>
              <td>{{ contact.areaPosition || '—' }}</td>
              <td>
                <span class="contacts-panel__chips">
                  @for (chip of chipsOf(contact); track chip) {
                    <span
                      class="contacts-panel__chip"
                      [class.contacts-panel__chip--risk]="chip === 'Relatório de Risco'">
                      {{ chip }}
                    </span>
                  }
                </span>
              </td>
              <!-- Observacao truncada com o texto completo no title: a coluna nao pode fazer a
                   linha crescer, mas o conteudo tem que continuar acessivel. -->
              <td class="contacts-panel__notes" [title]="contact.notes || ''">
                {{ contact.notes || '—' }}
              </td>
              @if (hasRowActions()) {
                <td class="contacts-panel__actions">
                  @if (canUpdate()) {
                    <button
                      type="button"
                      class="contacts-panel__action"
                      title="Editar contato"
                      [disabled]="isSaving()"
                      (click)="openEdit(contact)">
                      <i class="pi pi-pencil"></i>
                    </button>
                  }
                  @if (canDelete()) {
                    <button
                      type="button"
                      class="contacts-panel__action contacts-panel__action--danger"
                      title="Excluir contato"
                      [disabled]="isSaving()"
                      (click)="remove(contact)">
                      <i class="pi pi-trash"></i>
                    </button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  }

  <app-company-contact-modal #contactModal (confirmed)="onConfirmed($event)">
  </app-company-contact-modal>
</section>
